export const FORGOT_PASSWORD_EMAIL_KEY = 'email';
export const REDIRECT_SIGN_UP_CORP_KEY = 'corp';
export const REDIRECT_SIGN_UP_ENVIOS_KEY = 'envios';
export default {
  FORGOT_PASSWORD_EMAIL_KEY,
  REDIRECT_SIGN_UP_CORP_KEY,
  REDIRECT_SIGN_UP_ENVIOS_KEY
};
